// eslint-disable-next-line no-restricted-globals
const query = new URLSearchParams(location.search);

export const initialState = {
    username: query.get('username') || '',
    token: null,
    flash: { text: '', variant: 'success' },
    me: { role: 'unknown' },
};
